import { useMemo } from 'react';

import type { CoachChatConfig } from 'bundles/unified-common/providers/CoachStateProvider';
import { useSpecializationPageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';

type UseSpecializationContextConfigProps = {
  coachModeId: string;
  coachActionId: string;
};

const useSpecializationContextConfig = ({
  coachModeId,
  coachActionId,
}: UseSpecializationContextConfigProps): CoachChatConfig | undefined => {
  const specializationPageData = useSpecializationPageData();
  const specializationId = specializationPageData?.id;
  const specializationSlug = specializationPageData?.slug ?? '';
  const careerGrowthInPercentage = specializationPageData?.careerOutcomes?.careerGrowthInPercentage?.toString() ?? '';

  return useMemo(() => {
    if (!specializationId) {
      return undefined;
    }

    return {
      courseraContext: {
        specializationId,
      },
      config: {
        coachModeId,
        coachActionId,
      },
      additionalContext: [
        {
          contextKey: 'additionalContext.productSlug',
          contextValue: specializationSlug,
        },
        {
          contextKey: 'additionalContext.productType',
          contextValue: 'SPECIALIZATION',
        },
        ...(careerGrowthInPercentage
          ? [
              {
                contextKey: 'additionalContext.careerGrowthInPercentage',
                contextValue: `percentage-of-certificate-grads-report-career-improvement: ${careerGrowthInPercentage}%`,
              },
            ]
          : []),
      ],
    };
  }, [specializationId, specializationSlug, careerGrowthInPercentage, coachModeId, coachActionId]);
};

export default useSpecializationContextConfig;
